import warning from '../_util/warning';
var Icon = {
  name: 'AIcon',
  render: function render() {
    warning(false, 'Icon', 'Empty Icon');
    return null;
  }
};
/* istanbul ignore next */

Icon.install = function (app) {
  app.component(Icon.name, Icon);
};

export default Icon;